import ModalComponent from "../../module-modal-example/js/ModalComponent.js";

(function(){
    if (document.querySelector("[data-component='modal']")) {
        new ModalComponent({ toggle : "" }).openExample();
    }
}());
